// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"history__Wrapper_1F5fY","Title":"history__Title_3TdAo"};